import React, { CSSProperties } from 'react';
import classes from './MediaDraggedLayer.module.scss';
import { useDragLayer } from 'react-dnd';
import { MediaDragItem } from '../MediaItemDraggable/MediaItemDraggable.view';
import { Identifier, XYCoord } from 'dnd-core';
import { MediaItem } from '../MediaItem';
import { Portal } from '../../../components/containers/Portal';
import { DraggableTypesObject } from '../../../constants/drag-and-drop';

export const MediaDraggedLayerView = (): JSX.Element | null => {
  const { item, currentOffset, isDragging, itemType } = useDragLayer<
    {
      item: MediaDragItem;
      isDragging: boolean;
      currentOffset: XYCoord | null;
      initialOffset: XYCoord | null;
      itemType: Identifier | null;
    },
    MediaDragItem
  >(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset(),
    initialOffset: monitor.getInitialSourceClientOffset()
  }));

  if (!isDragging || !item.mediaItemProps || itemType !== DraggableTypesObject.POST_EDITOR_MEDIA) return null;

  const getItemStyles = (currentOffset: XYCoord | null, isSmall: boolean): CSSProperties => {
    if (!currentOffset)
      return {
        display: 'none'
      };

    const transform = `translate(${currentOffset.x}px, ${currentOffset.y}px) rotate(+2deg)`;

    return {
      margin: isSmall ? '0 8px 0 0' : '8px 8px 0 0',
      transform
    };
  };

  const { id, image, intentType, type, publishNext } = item.mediaItemProps;

  return isDragging ? (
    <Portal>
      <div className={classes.MediaDraggedLayer}>
        <div style={getItemStyles(currentOffset, item.isSmall)}>
          <MediaItem
            id={id}
            droppable={false}
            type={type}
            intentType={intentType}
            onClose={() => {
              // do nothing
            }}
            image={image}
            publishNext={publishNext}
            loading={false}
          />
        </div>
      </div>
    </Portal>
  ) : null;
};
